import { render, staticRenderFns } from "./RecurringBalanceInsight.vue?vue&type=template&id=63d192aa&scoped=true"
import script from "./RecurringBalanceInsight.vue?vue&type=script&lang=js"
export * from "./RecurringBalanceInsight.vue?vue&type=script&lang=js"
import style0 from "./RecurringBalanceInsight.vue?vue&type=style&index=0&id=63d192aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d192aa",
  null
  
)

export default component.exports